export const WEB_NEW_LOOKUP = 'api-web-new-lookup';
export const WEB_UAE_TDRA = 'api-web-uae-tdra';
export const WEB_LOOKUP = 'api-web-lookup';
export const WEB_MIN = 'api-web-min';
export const WEB_NEW = 'api-web-new';
export const WEB_NEW_V2 = 'api-web-new-v2';
export const APP = 'api-app';
export const WEB = 'api-web';
export const WEB_INDEX = 'api-web-index';

export const API_SOURCE_WEB_INITIATIVE = 'api-web-Initiative_MY_KSA_UAE_i1'

export const WIDE_V3_LAYOUT_API_SOURCE = 'api-web-androidtv'

export const WEB_STEPS_BLACK = 'api-web-Steps_Black_AR';
export const WEB_STEPS_BLACK_KW_AR = 'api-web-steps_black_KW_AR';
export const WEB_STEPS_WHITE = 'api-web-Steps_White_AR';
export const WEB_LOADED_WHITE = 'api-web-Loaded_White_AR';

export const WEB_STEPS_BLACK_EN = 'api-web-Steps_Black_EN';
export const WEB_CHECKMARK_WHITE_EN = 'api-web-checkmark_white_EN';
export const WEB_CHECKMARK_BLACK_EN = 'api-web-Checkmark_Black_EN';

export const V5_CHECKMARK = 'api-web-check_mark';
export const V5_DOWNLOAD_ICON = 'api-web-download_icon';
export const V5_PHONE_ICON = 'api-web-phone_icon';
export const V5_CHECKMARK_TRIAL = 'api-web-check_mark_trial';
export const V5_DOWNLOAD_ICON_TRIAL = 'api-web-watch_my_trial';

export const UAE_LG_AG26 = 'api-web-lg_ag26';
export const UAE_ST_AG26 = 'api-web-st_ag26';

export const V5_CHECKMARK_WEEKLY = 'api-web-check_mark_weekly';
export const V5_DOWNLOAD_ICON_WEEKLY = 'api-web-download_icon_weekly';
export const V5_PHONE_ICON_WEEKLY = 'api-web-phone_icon_weekly';

export const WEB_ETISALAT_IMMERSIVE = 'api-web-etisalat_immersive';

export const WEB_IQ_CAD = 'api-web-IQ_CAD';

export const WEB_AE_WK = 'api-web-ae_wk';

export const WEB_ORANGE_MOROCCO = 'api-web-orange_morocco';

export const SPECIFIC_API_SOURCES_FOR_OPERATOR_TEXT = [
  // WEB_STEPS_BLACK_EN,
  // WEB_CHECKMARK_WHITE_EN,
  // WEB_CHECKMARK_BLACK_EN,
  V5_CHECKMARK,
  UAE_LG_AG26,
  UAE_ST_AG26,
  V5_DOWNLOAD_ICON,
  V5_CHECKMARK_TRIAL,
  V5_DOWNLOAD_ICON_TRIAL,
  V5_PHONE_ICON,
  V5_CHECKMARK_WEEKLY,
  V5_DOWNLOAD_ICON_WEEKLY,
  V5_PHONE_ICON_WEEKLY,
];

export const SPECIAL_SOURCES_FOR_IQ_ZAIN = [
  'api-web-ZainIQD',
  'api-web-ZainIQW',
  'api-web-ZainIQM',
  'api-web-download_icon',
  'api-web-IQ_CAD',
  'api-web-Steps_White_AR',
];

export const SPECIFIC_API_SOURCES_FOR_OPERATOR_THIRD_TEXT = [WEB, WEB_NEW];
